export const SkeletonLoansPage = () => {
  return (
    <div className="pr-[40px] pl-[10px] animate-pulse">
      {/* Header */}
      <div className="h-[60px] flex items-center justify-between mb-4">
        <div className="h-[30px] w-[200px] bg-gray-300 rounded" />
        <div className="h-[40px] w-[120px] bg-gray-300 rounded-full" />
      </div>

      {/* Filter Bar */}
      <div className="flex gap-4 mb-5">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="w-[150px] h-[35px] bg-gray-200 rounded" />
        ))}
        <div className="w-[100px] h-[35px] bg-gray-300 rounded-full" />
      </div>

      {/* Summary Cards */}
      <div className="flex justify-between mb-6">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="w-[32%] h-[120px] bg-gray-200 rounded-lg" />
        ))}
      </div>

      {/* Loans Table Placeholder */}
      <div className="bg-white rounded-[8px] py-4 pc-[10px] mb-6">
        <div className="h-[20px] w-[200px] bg-gray-300 rounded mb-4" />
        <div className="space-y-3">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="h-[40px] w-full bg-gray-200 rounded" />
          ))}
        </div>
      </div>
    </div>
  );
};
